import { html,css,LitElement } from 'lit';
import { ContextConsumer } from '@lit/context';
import { msg,str } from '@lit/localize';
import { organisationContext } from '../../utilities/context';
import { EventManager } from '../../utilities/events';
import { decodeEntities } from '../../utilities/formsUtilities';
import { getTier } from '../../utilities/orgUtilities';
import { formatDateString } from '../../utilities/eventUtilities';
import { formStyles,grid } from '../../utilities/styles.js';
import { AllInConditionals } from '../Utilities/AllInConditionals.js';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
export class AllInOrganisationSubscriptions extends AllInConditionals(AllInOrganisationConsumer(LitElement)){
    static properties = {
        name: { type: String },
        _invoices: { type: Object, state:true},
        _subscriptions: { type: Object, state:true},
        loading: {type: Boolean, state:true},
        currentOrg: { type: String, state:true },
        groupProfiles: { type: Object, state: true },
        inviteResponse: { type: String, state:true }
    }

    constructor() {
        super();
        this.inviteResponse = '';
    }
    
    async connectedCallback() {
        super.connectedCallback();
        this.statuses = {
            'paid':msg(str`Paid`),
            'open':msg(str`Unpaid`),
            'void':msg(str`Cancelled`),
            'uncollectible':msg(str`Uncollectible`),
        }
        this.durations = {
            'OneYear':msg(str`One Year`),
            'TwoYears':msg(str`Two Years`),
            'ThreeYears':msg(str`Three Years`),
        }
        if(this.organisation){
            if(this.organisation.hasOwnProperty('invoices')){
                this._invoices = this.organisation.invoices;
                this._fetchInvoices();
            }
            else{
                this.loading = true;
                await this._fetchInvoices();
                this.loading = false;
                
            }
        }
        else{
            this.loading = true;
        }
        this.oldPanel = this.panel;
        await this._fetchGroupProfiles();
    }

    async updated(changedProperties){
        if(changedProperties.has('currentOrg')){
            this.organisation = this._getOrganisationById(this.currentOrg);
            if(this.organisation.hasOwnProperty('invoices')){
                this._invoices = this.organisation.invoices;
                this._fetchInvoices();
            }
            else{
                this.loading = true;
                await this._fetchInvoices();
                this.loading = false;
                
            }
            this.loading = false;
        }
        if(changedProperties.has('panel')&&this.panel!==this.oldPanel){
            this.oldPanel = this.panel;
            if(this.panel == 'group' && this._isAdmin() && this.groupFlag){
                let crumb = {
                    organisation:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/`,title:msg(str`${this.organisation?.name}`)},
                    dashboard:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/`,title:msg(`Subscriptions`)},
                    panel:{url:`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/group/`,title:msg(`Manage group`)}
                }
                this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
                this.eventManager.addHistory(`${this.hardlinks.organisation_dashboard}/${this.currentOrg}/subscriptions/group`,{panel:this.panel});
            }
        }
    }

    _handleContextUpdate(value){
        this.organisationData = value;
        ({currentOrg:this.currentOrg,organisations:this.organisations,name:this.name,panel:this.panel,panels:this._panels, restUrl:this.restUrl,nonce:this.nonce,action:this.action} = this.organisationData);
    }

    render(){

        let main;
        if(this._loading){
            main = html`<allin-loader loading></allin-loader>`;
        }
        const isLeadGroup = this.groupProfiles?.id === this.currentOrg;
        const isAssociateGroup = this.groupProfiles?.associatedOrganisations?.some(org => org.id === this.currentOrg);

        const leadOrgId = this.groupProfiles?.id;

        if(this.panel == 'group' && this._isAdmin() && this.groupFlag){
            return html`<allin-organisation-subscriptions-group name="${this.name}"></allin-organisation-subscriptions-group>`;
        }
        else{
            let currentSubscription, previousSubscription, unpaidInvoices;
            let notification = '';
            if(this._invoices && Array.isArray(this._invoices?.data) && this._invoices.data.length > 0){
                previousSubscription = html`<h3>${msg(str`Your previous invoices`)}</h3>
                ${this._invoices.data.map((invoice)=>{
                        if(invoice.status=='void') return '';
                        let extraLocations = invoice.metadata.extraLocations ? parseInt(invoice.metadata.extraLocations)  : 0;
                        let totalBaseLocations = invoice.metadata.totalOrganisations ? parseInt(invoice.metadata.totalOrganisations) : 0;
                        let totalLocations = totalBaseLocations + extraLocations;
                        return html`
                            <div class="bg">
                                 <dl class="grid grid_50 gap_4">
                                    <dt>Status</dt>
                                    <dd>${this.statuses[invoice.status]}</dd>
                                    <dt>${msg(str`Subscription level`)}</dt>
                                    <dd>${getTier(invoice.metadata.tier)}</dd>
                                    <dt>${msg(str`Created on`)}</dt>
                                    <dd>${formatDateString(invoice.created,false,false)}</dd>
                                    <dt>${msg(str`Subscription duration`)}</dt>
                                    <dd>${this.durations[invoice.metadata.duration]}</dd>
                                    <dt>${msg(str`Number of locations included in the subscription`)}</dt>                                   
                                    <dd>${totalLocations?totalLocations:'-'}</dd>
                                </dl>
                                ${/* invoice.status=='open'&&new Date(invoice.dueDate) < new Date(new Date().setHours(23, 59, 59, 0))?'Expired': */
                                html`<a href="${invoice.hostedInvoiceUrl}" class="button" target="_blank" rel="noopener">${msg(str`View invoice`)}</a>`}
                            </div>`
                        })
                }`;
                unpaidInvoices = this._invoices.data.filter((invoice)=>invoice.status=='open'&&new Date(invoice.dueDate) > new Date(new Date().setHours(23, 59, 59, 0)));
                if(unpaidInvoices.length>0){
                    notification = html`<div class="message">
                        <h4>${msg(str`You have ${unpaidInvoices.length==1?'an ':''}unpaid invoice${unpaidInvoices.length==1?'':'s'}`)}</h4>
                        <ul>
                           ${unpaidInvoices.map((invoice)=>html`
                            <li>
                                ${msg(str`You have an unpaid invoice. Please make the payment in order to unlock the subscription benefits.`)} 
                                <a href="${invoice.hostedInvoiceUrl}" target="_blank" rel="noopener">
                                    ${msg(str`View invoice`)}
                                </a>
                            </li>`)}
                        </ul>
                    </div>`
                }
            }
            else if(this._invoices == undefined){
                previousSubscription = html`<h3>${msg(str`Your previous subscriptions`)}</h3><allin-loader loading></allin-loader>`;
            }
            else{
                previousSubscription = html`<h3>${msg(str`Your previous subscriptions`)}</h3><p>${msg(str`You don't have any previous subscriptions.`)}</p>`;
            }
            if(this.organisation.subscriptionTier){
                let button = '';
                let _30daysFromNow = new Date();
                _30daysFromNow.setDate(_30daysFromNow.getDate() + 40);
                if(this._isAdmin()) {
                    
                    if(unpaidInvoices && unpaidInvoices.length>0){
                        button = html`
                        `;
                    }
                    else if(this.organisation?.subscriptionTier=='Tier1'){
                        button = html`
                        <button @click="${this._addSubscription}">${msg(str`Add subscription`)}</button>
                        `;
                    }
                    else if(this.organisation?.subscriptionEndDate && new Date(this.organisation.subscriptionEndDate) < _30daysFromNow){
                        button = html`
                        <button @click="${this._addSubscription}">${msg(str`Renew subscription`)}</button>
                        `;
                    }
                }
                let subscriptionNote = msg(str`Note: Only Primary Admin can make edits to the subscriptions.`);
                if(this._isAdmin()){
                    subscriptionNote = '';
                }
                if(isLeadGroup ){
                    subscriptionNote = html`
                        ${msg(str`You are the lead organisation of a group subscription.`)}
                        <a href="/organisation-dashboard/${this.currentOrg}/subscriptions/group" @click="${this._manageGroup}">${msg(str`Manage your group`)}</a>
                    `;
                    button = '';
                }
                else if(isAssociateGroup){
                    let invite = this.groupProfiles?.associatedOrganisations?.find(org => org.id === this.currentOrg);
                    if(invite && invite.invitedStatus === 'Accepted'){
                        subscriptionNote = html`
                            ${msg(str`Note: Your subscription is being managed as part of a group. Only the `)}
                            <a href="/organisation-dashboard/${this.currentOrg}/subscriptions/group" @click="${this._manageGroup}">${msg(str`leading organisation`)}</a>${msg(str` can make edits to the subscription.`)}
                        `
                        button = '';
                        if(this.inviteResponse){
                            subscriptionNote = html`<div class="invites">
                                <h4>${msg(str`Your subscription group invites`)}</h4>
                                <p>${this.inviteResponse}</p>
                            </div>`;
                        }
                    }
                    else if(invite && (invite.invitedStatus === 'Pending' || invite.invitedStatus === 'Invited')){
                        let _groupInvites = this.user?.groupInvites?.filter((_invite)=>_invite.name==invite.name);
                        if(_groupInvites.length > 0){
                            subscriptionNote  =  html`<div class="invites">
                                <h4>${msg(str`Your subscription group invites`)}</h4>
                                <ul>
                                    ${_groupInvites.map((_invite)=>{
                                        let org = this.organisations.find((org)=>org.name==_invite.name);
                                        return html`<li>
                                        <strong>${msg(str`${_invite.name} has been invited to join a subscription group`)}</strong>
                                        <div class="grid grid_50">
                                            <button @click=${(e)=>this._handleGroupInvite(_invite.id, org.org_id,true, e)}>${msg(str`Accept invite`)}</button>
                                            <button @click=${(e)=>this._handleGroupInvite(_invite.id, org.org_id,false, e)}>${msg(str`Decline invite`)}</button>
                                        </div>
                                    </li>`})}
                                </ul>
                            </div>`;
                            if(this.inviteResponse){
                                subscriptionNote = html`<div class="invites">
                                    <h4>${msg(str`Your subscription group invites`)}</h4>
                                    <p>${this.inviteResponse}</p>
                                </div>`;
                            }
                            button='';
                        }
                    }
                }
                if(this._subscriptions && this._subscriptions.length>0){
                    let subscriptions = this._subscriptions.sort((a,b)=>new Date(b.subscriptionEndDate)-new Date(a.subscriptionEndDate));
                    let currentSubData = subscriptions[0];
                    let subscriptionDuration = currentSubData.subscriptionEndDate && currentSubData.createdAt ? Math.round((new Date(currentSubData.subscriptionEndDate).getYear()-new Date(currentSubData.createdAt).getYear())) : null;
                    
                    currentSubscription = html`<h3>${msg(str`Your current subscription`)}</h3>
                        <div class="bg">
                            <dl class="grid grid_50 gap_4">
                                <dt>${msg(str`Subscription level`)}</dt>
                                <dd>${getTier(currentSubData.tierConfiguration)}</dd>
                                <dt>${msg(str`Date of purchase`)}</dt>
                                <dd>${currentSubData.createdAt?formatDateString(currentSubData.createdAt,false,false):'-'}</dd>
                                <dt>${msg(str`Subscription duration`)}</dt>
                                <dd>${subscriptionDuration?`${subscriptionDuration} Year${subscriptionDuration > 1 ? 's' : ''}`:'-'}</dd>
                                <dt>${msg(str`End of subscription`)}</dt>
                                <dd>${currentSubData.subscriptionEndDate?formatDateString(currentSubData.subscriptionEndDate,false,false):'-'} </dd>
                                <dt>${msg(str`Number of locations included in the subscription`)}</dt>                                   
                                <dd>${parseInt(currentSubData.totalLocations)}</dd>
                            </dl>
                        </div>
                        ${button}
                        <div class="admin-subscr-note">
                            <p>
                                ${
                                subscriptionNote
                                }
                            </p>
                        </div>
                    `;
                }
                else{
                currentSubscription = html`<h3>${msg(str`Your current subscription`)}</h3>
                        <div class="bg">
                            <dl class="grid grid_50 gap_4">
                                <dt>${msg(str`Subscription level`)}</dt>
                                <dd>${getTier(this.organisation.subscriptionTier)}</dd>
                                <dt>${msg(str`End of subscription`)}</dt>
                                <dd>${this.organisation.subscriptionEndDate?formatDateString(this.organisation.subscriptionEndDate,false,false):'-'}</dd>
                        </div>
                        ${button}
                        <div class="admin-subscr-note">
                             <p>
                                ${
                                subscriptionNote
                                }
                            </p>
                        </div>
                    `;  
                }
            }
            
            main = html`${notification}${currentSubscription}${previousSubscription}`;
        }
        return html`<h2>${decodeEntities(this.organisation.name)} ${msg(str`subscriptions`)}</h2>${main}`;
    }

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }

    async _fetchInvoices(){
        let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-invoices&nonce=${this.nonce}`;
        try{
            let response = await fetch(url,{
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            if(response.status === 403){
                handle403s();
                return;
            }

            let data = await response.json();
            //console.log(data);
            this._invoices = data.invoices;
            this._subscriptions = data.subscriptions;
            this.organisation.invoices = this._invoices;
            this.organisation.subscriptions = this._subscriptions;
            this.eventManager.emit(`allin-organisation-${this.name}-update`,{organisation:JSON.stringify(this.organisation)});
        }
        catch(error){
            console.error('Error:', error);
        };   
    }


    _addSubscription(){
        window.location.href = `${this.hardlinks.organisation_dashboard_add_subscription}?org_id=${this.currentOrg}`;
    }

    _manageGroup(e){
        e.preventDefault();
        this.panel = 'group';
        this._updateContext({panel:this.panel})
    }

    async _fetchGroupProfiles(){
    let url = `${this.restUrl}?org_id=${this.currentOrg}&action=${this.action}-group&nonce=${this.nonce}`;
    
    try {
        let response = await fetch(url, {
        headers: { 'AllIn-Nonce': this.nonce }
        });

        if(response.status === 403){
            handle403s();
            return;
        }

            let data = await response.json();

            this.groupProfiles = data.group;


        } catch (error) {
            console.error('Error:', error);
        }
    }

    async _handleGroupInvite(inviteId, orgId, accept, e) {
        e.preventDefault();
        const button = e.currentTarget;
        button.disabled = true; // Disable the button to prevent multiple clicks
        button.classList.add('loading'); // Optionally add a loading class for styling
        let url = `${this.restUrl}`;
        try{
            let response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                },
                body: JSON.stringify({ 
                    invite_id:inviteId, 
                    status:accept?'Accepted':'Rejected', 
                    org_id:orgId,
                    action:`${this.action}-handle-group-invite` 
                }),
            });
            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }
            let data = await response.json();
            if(data.ok){
                // Handle the response data
                let groupInvite = this.user.groupInvites.findIndex(invite => invite.id === inviteId);
                if (groupInvite !== -1) {
                    this.user.groupInvites[groupInvite].inviteStatus = data.status;
                }
                this.inviteResponse = data.status === 'Accepted' ? msg(str`You have successfully accepted the group invite.`) : msg(str`You have declined the group invite.`);
                this.user = {...this.user};

                this._updateContext({user:this.user});
            }
            else{
                this.inviteResponse = msg(str`There was an error processing your request. Please try again later.`);
                console.error('Error handling group invite:', data.error);
            }
        }
        catch(error) {
            console.error('Error handling group invite:', error);
        }
        button.disabled = false;
        button.classList.remove('loading');
    }


    static styles = [
        formStyles,
        grid,
        css`
         .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .gap_4{
            row-gap:1rem;

        }
        dl{
            margin-top:0;
        }
        dl:has(+a){
            margin-bottom:2rem;
        }

        .message{
            background-color: var(--allin-button-bg-color,#fff);
            border: 1px solid var(--allin-button-color,#472961);
            padding:1rem;
            margin-bottom:1rem;
        }

        .message ul{
            list-style:disc;
            padding-left:1rem;
            margin:0;
        }

        .message ul li{
            display:list-item;
        }

        .message ul li a{
            color: var(--allin-button-color,#472961);
            text-decoration: underline;
            padding:0;
            border:none;
            background:transparent;
        }
        .message h4{
            margin-top:0;
        }

        .admin-subscr-note {
            p{
                margin-top: 1rem;
            }
            a{
                color: var(--allin-button-color,#472961);
            }
        }

        .invites ul{
            padding:0;
            .grid{
                gap:1rem;
            }
            li{
                background-color: var(--color-grey);
                padding: 2rem;
                display:block;
                strong{
                    margin-bottom:1rem;
                    display:block;
                }
                button.loading{
                    opacity:0.6;
                    pointer-events:none;
                }
            }
        }

        `
    ];
}
